<template>
    <div
        v-if="subpropertyId"
        class="subproperty-home-page"
    >
        <subproperty-requirement-steps />
        <subproperty-dashboard-finantial
            v-if="!isPropertyNBA"
            :subproperty-id="subpropertyId"
            :hidden-links="false"
        />
        <subproperty-dashboard />
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import HomePage from '@modules/home/components/home-page.vue';
import SubpropertyRequirementSteps from '@modules/subproperty/components/subproperty-requirement-steps.vue';
import SubpropertyDashboard from '@modules/subproperty/components/subproperty-dashboard.vue';
import SubpropertydashboardFinantial from '@modules/subproperty/components/subproperty-dashboard-finantial.vue';

export default {
    name: 'SubpropertyHomePage',
    components: {
        [HomePage.name]: HomePage,
        [SubpropertyRequirementSteps.name]: SubpropertyRequirementSteps,
        [SubpropertyDashboard.name]: SubpropertyDashboard,
        [SubpropertydashboardFinantial.name]: SubpropertydashboardFinantial,
    },
    computed: {
        ...mapGetters({
            currentManage: 'auth/manage/currentManage',
            isPropertyNBA: 'auth/manage/isPropertyNBA',
        }),
        subpropertyId() {
            return this.currentManage.subproperty.id;
        },
    },

    methods: {
        ...mapActions({
            doFetch: 'subproperty/list/doFetch',
        }),
    },
    
    created() {
        this.doFetch();
    },
}
</script>